






















































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import SuporteTipoAcomodacaoStore from '@/components/Suporte/Store/SuporteTipoAcomodacaoStore'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteTipoAcomodacao extends Vue {
  loadEditTipoAcomodacao: string = ''

  get getSuporteTipoAcomodacaoStore() {
    return getModule(SuporteTipoAcomodacaoStore, this.$store)
  }

  get paginationTipoAcomodacao() { return this.getSuporteTipoAcomodacaoStore.paginationTipoAcomodacao }
  get loadingEditTipoAcomodacao() { return this.loadEditTipoAcomodacao }
  set loadingEditTipoAcomodacao(value: string) { this.loadEditTipoAcomodacao = value }
  get hospitalId() { return this.getSuporteTipoAcomodacaoStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteTipoAcomodacaoStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      hospital.utilizaTipoAcomodacaoHospital = !!h.utilizaTipoAcomodacaoHospital
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get tipoAcomodacaoHeaders() {
    return [
      { text: 'Descrição', value: 'descricao', sortable: false },
      { text: 'HisId', value: 'hisId', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get tipoAcomodacaoList() { return this.getSuporteTipoAcomodacaoStore.tipoAcomodacaoList }
  get searchTipoAcomodacao() { return this.getSuporteTipoAcomodacaoStore.searchTipoAcomodacao }
  set searchTipoAcomodacao(value: string) { this.getSuporteTipoAcomodacaoStore.setSearchTipoAcomodacao(value) }

  async hospitalChange(hospital: any) {
    this.getSuporteTipoAcomodacaoStore.setSearchTipoAcomodacao('')
    this.getSuporteTipoAcomodacaoStore.setHospital(hospital)
    this.getSuporteTipoAcomodacaoStore.setHospitalId(hospital.id)

    await this.getSuporteTipoAcomodacaoStore.getAllTipoAcomodacaoByHospitalId(hospital.id)
  }

  async adicionarTipoAcomodacao() {
    this.getSuporteTipoAcomodacaoStore.setMode('CREATE')
    this.getSuporteTipoAcomodacaoStore.clearTipoAcomodacao()
    this.getSuporteTipoAcomodacaoStore.setModal({ name: 'tipoAcomodacao', value: true })
  }

  async editarTipoAcomodacao(item: any) {
    this.loadingEditTipoAcomodacao = item.id
    this.getSuporteTipoAcomodacaoStore.setMode('EDIT')
    this.getSuporteTipoAcomodacaoStore.setTipoAcomodacao({ ...item })
    this.getSuporteTipoAcomodacaoStore.setModal({ name: 'tipoAcomodacao', value: true })
    this.loadingEditTipoAcomodacao = ''
  }

  beforeDestroy() {
    this.getSuporteTipoAcomodacaoStore.clearTipoAcomodacaoList()
    this.getSuporteTipoAcomodacaoStore.clearHospitalId()
  }
}
